/* eslint-disable no-undef */
'use strict';

var utils = require('plugin_jac/util');

module.exports = function () {
	var carouselContainer = $('.s7-carousel');
	var deviceWidth = $(window).width();
	if (carouselContainer.length > 0) {
		carouselContainer.each(function (index, element) {
			var zoomViewer;
			var viewerConfig =
                deviceWidth <= 1280 ? window.SitePreferences.SCENE7_CYO_CONFIG : window.SitePreferences.SCENE7_PDP_CONFIG;
			var swatchesAlign =
                deviceWidth <= 1280 ? 'left,bottom' : 'left,top';
			var swatchTblLayout = deviceWidth <= 1280 ? '0,1' : '1,0';
			var enableZoomHandler = (deviceWidth <= 1280 || $(element).parents('.product-detail').hasClass('product-quickview')) ? true : false;
			zoomViewer = new s7viewers.MixedMediaViewer({
				containerId: $(element).attr('id'),
				params: {
					asset: $(element).data('assetid'),
					serverurl: 'https://jamesavery.scene7.com/is/image/',
					videoserverurl: 'https://jamesavery.scene7.com/is/content/',
					config: 'JamesAvery/' + viewerConfig,
					contenturl: 'https://jamesavery.scene7.com/is/content/',
					'FlyoutZoomView.tip': '0,0,0.0',
					'Swatches.align': swatchesAlign,
					'Swatches.tmblayout': swatchTblLayout,
					'Swatches.enableScrollButtons' : enableZoomHandler ? '0' : '1',
					swatchoverlay: '0',
					'ZoomView.iconeffect': '0'
				},
				handlers: {
					initComplete: function initComplete() {
						var id = $(element).attr('id');
						var target = $('#'+$(element).attr('id')+'_swatches');
						var swatchCount = $(target).find('.s7thumbcell').length;
						if(swatchCount == 1){
							$(target).parents('.s7-carousel').addClass('swatch-wrapper');
							$(target).css('visibility','inherit');
						}
						(deviceWidth <= 1280) ? $(target).children().addClass('swatch-container') : '';
						(deviceWidth <= 1280 && swatchCount > 1) ? utils.selectSwatchOnViewerSwipe(zoomViewer,$(element)) : '';
						utils.onLoadSEOUpdateOnViewerImages(id);
						utils.dynamicSEOUpdateOnViewerImages(id);
					}
				},
			});
			zoomViewer.init();
		});
	}
};
